import React from 'react';

import {
  CTA_UNLOCK_YOUR_TEENS_OFFER,
  DISCLAIMER_CONSULTATION_CANCEL,
  FAQ_HOW_DOES_A_TRIAL_WORK_ANSWER,
  FAQ_HOW_DOES_A_TRIAL_WORK_QUESTION,
} from 'consts/copy';
import { PAGE_URLS } from 'consts/pageUrls';
import { EXTERNAL_URLS } from 'consts/externalUrls';

import type { FaqProps } from '..';

export const FAQ_MOMS_OF_TEENS_MARKETING_SAFE_CONTENT: FaqProps = {
  header: 'FAQs',
  faqs: [
    {
      question: 'Is Curology safe for sensitive skin?',
      answer:
        'Most Curology products are designed to be non-comedogenic, dye-free, paraben-free, and hypoallergenic. Our formulas are gentle, yet effective, and generally well-tolerated by most members. Curology is 100% cruelty-free, vegan and Leaping Bunny certified.',
    },
    {
      question: 'How long does it take to see results?',
      answer:
        'The process of adjusting to the formula is as personal as your teen’s custom mix. Many see improvement within 3-4 weeks, but others may take longer. Some may experience dryness or temporarily worsened breakouts in the beginning. If your teen has questions, their personal provider is here to help troubleshoot.',
    },
    {
      question:
        'How do Curology providers diagnose and treat skin conditions online?',
      answer:
        'Your teen’s skin will be examined via high-quality photos of their face by a licensed provider. Many members find this process more convenient than traditional in-office visits, and you or your teen can message their provider at any time. In rare cases, providers may recommend local in-person treatment instead of Curology-in this case, you won’t be charged further.',
    },
    {
      question: 'What age do you have to be to use Curology?',
      answer:
        'We do not treat patients under 13 years old. For patients 13 to 17, parent or guardian consent is required, and treatment occurs in collaboration with the patient’s parent or guardian. These members will be required to include a parent or guardian’s name, email, and phone number, and in some states, a photo of their parent or guardian’s ID.',
    },
    {
      question: FAQ_HOW_DOES_A_TRIAL_WORK_QUESTION,
      answer: FAQ_HOW_DOES_A_TRIAL_WORK_ANSWER,
    },
    {
      question: 'Can I use other skincare products while using these products?',
      answer: (
        <React.Fragment>
          Definitely! While we aim to provide a simple day-to-day routine, our
          products are formulated to be versatile enough for your teen to use
          other skincare products, too. Just watch out for ones with potentially
          irritating or questionable ingredients. You can learn more about what
          ingredients to look out for in our{' '}
          <a href={PAGE_URLS.blog.home} target="_blank" rel="noreferrer">
            blog
          </a>
          , or ask your Curology provider.
        </React.Fragment>
      ),
    },
    {
      question: 'Is Curology just for the face? What about body breakouts?',
      answer: (
        <React.Fragment>
          Our custom product is intended for the face, but we also launched our
          own body wash! Learn more{' '}
          <a
            href={EXTERNAL_URLS.acneBodyWashArticle}
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
          .
        </React.Fragment>
      ),
    },
  ],
  ctaButton: {
    buttonText: CTA_UNLOCK_YOUR_TEENS_OFFER,
    disclaimerText: DISCLAIMER_CONSULTATION_CANCEL,
  },
};
